import React,{useState,useEffect} from 'react'
import Main from '../Main'
import BackToService from './BackToService';
import generator from 'generate-password'
import copy from 'copy-to-clipboard';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

function PasswordGenerator() {

    const [password, setPassword] = useState("");
    const [passwordLength, setPasswordLength] = useState(10);

    var copyToClipBoard = () =>{
        copy(password);
        toast('Copied', {
            type: "success",
        });
    }

    const fetchDetails = () =>{
        try{
            var password = generator.generate({
                length: passwordLength,
                numbers: true,
                symbols : true,
                excludeSimilarCharacters : true,
                strict:true
            });
            setPassword(password);
        }catch(e){
        }
    }

    useEffect(() =>{
        fetchDetails();
    },[])
    return (
        <>
            <Main active="service">
                <ToastContainer autoClose={2000}/>
                <div className="main">
                    <section>
                        <div className="container section-title">
                            <h2>Password Generator <BackToService /></h2>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card password-div">
                                        <div className="card-body password-body">
                                            <h1 style={{"marginBottom":"80px","textShadow": "3px 3px 3px lightgray","color":"#3c5d72"}}>Generate your strong password!</h1>
                                            <div className="input-group mb-3" style={{"width":"250px"}}>
                                                <input type="text" className="form-control" value={passwordLength} onChange={(e) => setPasswordLength(e.target.value)} placeholder="Search Github User" ariaLabel="Recipient's username" ariaDescribedby="basic-addon2" />
                                                <div className="input-group-append">
                                                    <button className="btn btn-primary" type="button" disabled={passwordLength?false:true} onClick={fetchDetails}>Generate</button>
                                                </div>
                                            </div>
                                            <div className="row p-g-d">
                                                <div className="p-g" title={password}>
                                                    {password}    
                                                </div>
                                                <span className="p-g-s" title="click to copy" onClick={copyToClipBoard}><i className="bx bx-copy"></i></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>          
                        </div>
                                
                        </div>
                        </section>
                    </div>
            </Main> 
        </>
    )
}

export default PasswordGenerator
